import React from 'react';
import {
  Box,
  FormControlLabel,
  FormGroup,
  IconButton,
  Paper,
  TextField,
  Checkbox,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ClearIcon from '@mui/icons-material/Clear';
import { ChoiceWithTextPayloadOptions } from '../../redux/types';

type Props = {
  option: ChoiceWithTextPayloadOptions;
  optionIndex: number;
  handleEditOption: (
    item: ChoiceWithTextPayloadOptions, text: string,
    textBoxOption: {
      enableTextBox: boolean, placeholderText?: string, textBoxInputRequired?: boolean,
    },
  ) => void;
  handleDeleteOption: (item: ChoiceWithTextPayloadOptions) => void;
}

const ChoiceTextQuestionOptionEditor = ({
  option,
  optionIndex,
  handleEditOption,
  handleDeleteOption,
}: Props): JSX.Element => (
  <Box display="flex" alignItems="center" sx={{ pl: 2, my: 1 }} gap={1}>
    <Paper elevation={option.isTNA ? 1 : 0} sx={{ flexGrow: 0.5, p: 2, bgcolor: option.isTNA ? 'grey.300' : '' }}>
      <TextField
        variant="standard"
        size="small"
        label={option.isTNA ? <FormattedMessage id="questionEditor.technicallyNotEvaluable" /> : `Option ${optionIndex}`}
        value={option.text}
        onChange={
          (evt: React.ChangeEvent<HTMLInputElement>) => {
            handleEditOption(
              option,
              evt.target.value,
              {
                placeholderText: option.placeholder,
                enableTextBox: option.textBox,
                textBoxInputRequired: option.textBoxInputRequired,
              },
            );
          }
        }
        fullWidth
      />
    </Paper>
    <Paper elevation={0} sx={{ flexGrow: 0.5 }}>
      <FormGroup>
        <Box display="flex" sx={{ flexDirection: 'row' }}>
          <FormControlLabel
            onChange={
              (evt, checked) => handleEditOption(
                option,
                option.text,
                {
                  placeholderText: option.placeholder,
                  enableTextBox: checked,
                  textBoxInputRequired: checked ? option.textBoxInputRequired : false,
                },
              )
            }
            checked={option.textBox}
            control={<Checkbox />}
            label="Enable Text Input"
            componentsProps={{ typography: { variant: 'body2' } }}
          />
          {
            option.textBox && (
              <FormControlLabel
                onChange={
                  (evt, checked) => handleEditOption(
                    option,
                    option.text,
                    {
                      placeholderText: option.placeholder,
                      enableTextBox: option.textBox,
                      textBoxInputRequired: checked,
                    },
                  )
                }
                checked={option.textBoxInputRequired}
                control={<Checkbox />}
                label="Required"
                componentsProps={{ typography: { variant: 'body2' } }}
              />
            )
          }
        </Box>
        {
          option.textBox && (
            <TextField
              size="small"
              label="Enter text input label"
              value={option.placeholder || ''}
              onChange={
                (evt: React.ChangeEvent<HTMLInputElement>) => {
                  handleEditOption(
                    option,
                    option.text,
                    {
                      placeholderText: evt.target.value,
                      enableTextBox: option.textBox,
                      textBoxInputRequired: option.textBoxInputRequired,
                    },
                  );
                }
              }
            />
          )
        }
      </FormGroup>
    </Paper>
    <IconButton
      aria-label={`delete-option ${option.id}`}
      onClick={() => { handleDeleteOption(option); }}
      size="large"
    >
      <ClearIcon />
    </IconButton>
  </Box>
);

export default ChoiceTextQuestionOptionEditor;
